module.exports = __webpack_public_path__ + "static/img/img_form1_zh_cn.5a2677a1.png";